<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>[{{model.type ? model.type.toUpperCase() : '-'}}]</strong>
            <strong>{{model.title}}</strong> <span class="float-right">{{model.created_at | sdate}}</span>
          </div>
          <h4>Group info</h4>
          <hr>
          <b-row v-if="model.group">
            <b-col md="6">
              <b-form-group>
                  <label for="opt_group_name">Group</label>
                  <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_group_name" v-model="model.group.groupname"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                  <label for="opt_group_name">Service</label><br>
                  <b-badge :disabled="lock" @keydown.enter="refresh" :variant="model.group.service === 'Basic' ? 'info' : 'success'" id="opt_group_name"> {{model.group.service}} </b-badge>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12" class="text-center">
              <p>not found matched group</p>
            </b-col>
          </b-row>
          <hr>
          <h4>From</h4>
          <hr>
          <b-row v-if="model.user">
            <b-col md="6">
              <b-form-group>
                  <label for="opt_username">Username</label>
                  <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_username" v-model="model.user.username"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                  <label for="opt_user_permission">Permission</label>
                  <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_user_permission" v-model="model.user.permissions"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12" class="text-center">
              <p>
                not found matched user
              </p>
            </b-col>
          </b-row>
          <hr>
          <h4>
            Q&A info
          </h4>
          <hr>
          <b-row>
            <b-col md="12">
              <select v-model="model.type" class="w-100" disabled>
                <option disabled value="">Please select solution</option>
                <option value="webcastle">WEBCastle : Web Firewall</option>
                <option value="wsfinder">WSFinder : Anti-Webshell</option>
                <option value="wmds">WMDS : Web Malware Detection System</option>
                <option value="wfdetector">WFDetector : Web Forgery Detection</option>
                <option value="etc">Etc</option>
              </select>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <h4 for="ph_question">Question</h4>
              <vue-editor disabled v-model="model.question" id="ph_question"></vue-editor>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <span class="pull-right">{{model.answered_at | datetime}}</span>
              <h4 for="ph_answer">Answer</h4>
              <vue-editor :disabled="lock" v-model="model.answer" id="ph_answer"></vue-editor>
            </b-col>
          </b-row>
          <hr>
          <b-button v-if="lock" size="sm" variant="primary" @click="edit"> Edit </b-button>
          <b-button v-else size="sm" variant="success" @click="save"> Save </b-button>
          <!-- <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button> -->
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove(model)" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <!-- {{model}} -->
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { Api } from '@/service';
export default {
  components: { VueEditor },
  data : () => ({ confirm: false, add: false, lock: true, model : {} }),
  methods: {
    cancel() { this.lock = true },
    edit() { this.lock = false },
    async update(m) {
      if(!(m.title || '').trim()) { return this.$toastr.e('Title is Require.'); }
      if(!(m.content || '').trim()) { return this.$toastr.e('Content is Require.'); }
      try {
        let rs = await Api.Partner_Call('borad.qna', m.id ? 'update' : 'insert', m);
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);this.$emit('refresh'); this.cancel();
        } else {
          this.$toastr.e('save', "failed"); this.$emit('refresh'); this.cancel();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
      m.edit = false;
    },
    async remove() {
      try {
        let rs = await Api.Partner_Call('board.qna', 'remove', { id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          this.$toastr.e('remove', "failed")
        }
        this.list(); this.$emit('refresh')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      if(!(this.model.answer || '').trim()) { return this.$toastr.e('Answer is Require.'); }

      try {
        let rs = await Api.Partner_Call('board.qna', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.$emit('refresh');
          this.cancel();
        } else {
          this.$toastr.s('Save', 'failed');
          this.$emit('refresh');
          this.cancel();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { this.$router.push({ name: 'board_qna'}); },
    async get(id = this.$route.params.id) {
      console.log('qan.detail.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await Api.Partner_Call('board.qna', 'detail', { id : id });
          this.model = Object.assign({}, this.model, rs.body );
          return;
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created() { console.log('qan.detail.vue', 'created'); },
  destroyed() { console.log('qan.detail.vue', 'destroyed'); },
  mounted() { console.log('qan.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}
</script>
